import React, { useContext, useEffect, useState } from 'react'
import CustomImage from '../../components/customImage/customImage'
import { isEmpty } from 'lodash'
import useTemplateHook from '../../components/template/templateHook'
import { getProductImage } from '../../utils/helper'
import getSymbolFromCurrency from 'currency-symbol-map'
import { useNavigate, useParams } from 'react-router'
import { PRODUCT_FILTER_API } from '../../utils/apiUrls'
import useAxios from 'axios-hooks'
import { AppContext } from '../../context/app'

const EcommMetaData = () => {
  const categoryId = useParams().categoryId
  const categoryName = useParams().categoryName
  const navigate = useNavigate()
  const { getTemplateImage } = useTemplateHook()
  const { setLoader } = useContext(AppContext)
  const [product, setProduct] = useState([])

  const [{ data: relatedProducts, loading: relatedProductsLoading }, relatedProductsCall] =
    useAxios(
      {
        url: `${PRODUCT_FILTER_API}`,
        method: 'post',
      },
      { manual: true },
    )

  useEffect(() => {
    relatedProductsCall({
      data: {
        categories: [categoryId],
      },
    })
  }, [])

  useEffect(() => {
    setLoader(relatedProductsLoading)
  }, [relatedProductsLoading])

  useEffect(() => {
    if (relatedProducts && relatedProducts.success) {
      const temp = relatedProducts.data
      setProduct(temp)
    }
  }, [relatedProducts])

  return (
    <div className="w-full">
      <div className="max-w-[1269px] mx-auto px-4 sm:px-6 lg:px-8">
        <div
          style={{
            borderTopLeftRadius: '6px',
            borderTopRightRadius: '6px',
            background: `#0f172195`,
          }}
          className={`w-full px-6 flex justify-between items-center py-[9px] xl:relative mt-2 xl:mt-4`}
        >
          <p
            style={{
              color: '#00ffff',
            }}
            className={`w-full line-clamp-1 text-sm xl:text-[22px] font-bold`}
          >
            {categoryName || 'Products'}
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-6 py-5 md:py-10 xl:py-6">
          {!isEmpty(product) &&
            product.map((item, index) => (
              <div
                key={item._id}
                className="relative group cursor-pointer "
                onClick={() => navigate(`/product/${item._id}`)}
              >
                <div className="">
                  {/* Image Container */}
                  <div className="relative">
                    <CustomImage
                      imageUrl={getTemplateImage(getProductImage(item?.img_s3_keys))}
                      imgAlt={item.title}
                      imgClass="w-full h-full object-cover"
                      loaderClass="w-full h-full"
                      imgStyle={{ borderRadius: '10px' }}
                    />
                  </div>
                  {/* Content */}
                  <div className="py-2">
                    <p className="text-white text-[10px] sm:text-sm md:text-base font-semibold line-clamp-2">
                      {item.title}
                    </p>

                    {/* Price Section */}
                    <div className="flex items-center gap-2 mt-2 flex-wrap">
                      <span className="bg-[#ff6600] text-white rounded text-[10px] sm:text-xs md:text-sm px-1 py-[2px] font-semibold">
                        {item?.discount?.enabled
                          ? parseInt(
                              item?.price -
                                (item?.price * parseInt(item?.discount.discount_value)) / 100,
                            )
                          : parseInt(item?.price)}{' '}
                        {getSymbolFromCurrency(item.currency || 'USD')}
                      </span>

                      {item?.discount?.enabled && (
                        <>
                          <span
                            className="text-[10px] sm:text-xs md:text-sm line-through"
                            style={{ color: '#808080' }}
                          >
                            {item.price} {getSymbolFromCurrency(item.currency || 'USD')}
                          </span>

                          <span className=" text-[#ff6600] text-[10px] sm:text-xs md:text-sm font-semibold">
                            ({item?.discount.discount_value}
                            {item?.discount.value_type === 'percentage' ? '%' : ''}) OFF
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  )
}

export default EcommMetaData
